import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import * as Components from '_components';
import { useWidgetRegister } from '_frameRegister';
import * as Styles from './Widget.module.scss';
export function WidgetRender(component, index) {
    function mapType(type) {
        switch (type) {
            case 'Button':
                return Common.WidgetSize.Button;
            case 'Frame':
                return Common.WidgetSize.Frame;
            case 'FullScreen':
                return Common.WidgetSize.FullScreen;
            default:
                throw new Error(`Unknown widget type: ${type}`);
        }
    }
    return (_jsx(Widget, { id: component.properties.id, type: mapType(component.properties.type), placementManager: {
            getWidgets(widgets, type, name) {
                return [];
            },
        } }, index));
}
export function WidgetPlaceholder(props) {
    const [widgets, placementManager] = Common.useWidgets();
    const placeholderWidgets = React.useMemo(() => {
        return placementManager.getWidgets(widgets, props.type, props.name);
    }, [widgets, props.type, props.name]);
    if (props.type === Common.WidgetPlaceholderType.Docked) {
        return _jsx(_Fragment, {});
    }
    if (props.type === Common.WidgetPlaceholderType.Tiles) {
        return _jsx(_Fragment, {});
    }
    if (props.type === Common.WidgetPlaceholderType.Floating) {
        return (_jsx(FloatingWidgetPlaceholder, { widgets: placeholderWidgets, placementManager: placementManager }));
    }
    throw new Error('Unknown placeholder type: ' + props.type);
}
export function Widget(props) {
    const widgets = useWidgetRegister();
    const widget = widgets.find(w => w.id === props.id);
    if (!widget) {
        return _jsxs("div", { children: ["Widget not found: ", props.id] });
    }
    function renderComponent(widget, size) {
        const cmp = widget.components[size];
        if (!cmp) {
            return _jsx("div", { children: "Unsupported widget size." });
        }
        return _jsx(Components.Content, { component: cmp });
    }
    switch (props.type) {
        case Common.WidgetSize.Button:
            return renderComponent(widget, Common.WidgetSize.Button);
        case Common.WidgetSize.Frame:
            return (_jsx(FrameWidget, { id: widget.id, placementManager: props.placementManager, title: widget.title, children: renderComponent(widget, Common.WidgetSize.Frame) }));
        case Common.WidgetSize.FullScreen:
            return renderComponent(widget, Common.WidgetSize.FullScreen);
        default:
            return _jsxs("div", { children: ["Unknown Widget Type: ", props.type] });
    }
}
export function ButtonWidget(props) {
    return _jsx(Components.Button, { children: props.children });
}
export function FrameWidget(props) {
    return (_jsxs(Components.Frame, { children: [_jsx(Components.FrameComponent, { side: Components.FrameComponentType.Left, type: Components.FrameSideType.Small }), _jsxs(Components.FrameComponent, { side: Components.FrameComponentType.Top, type: Components.FrameSideType.Small, children: [_jsx(Components.FrameSegment, { children: _jsx("h1", { children: _jsx(Components.MLT, { text: props.title }) }) }), _jsx(Components.FrameSegment, { type: Components.FrameSegmentType.Empty }), _jsx(Components.FrameSegment, { children: _jsxs(Components.BtnGroup, { children: [_jsx(Components.Button, { children: "_" }), _jsx(Components.Button, { children: "[ ]" }), _jsx(Components.Button, { children: "X" })] }) })] }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Right, type: Components.FrameSideType.Small }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Bottom, type: Components.FrameSideType.Small }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Content, children: props.children })] }));
}
export function FullScreenWidget(props) {
    return _jsx(_Fragment, { children: props.children });
}
function FloatingWidgetPlaceholder(props) {
    return (_jsx("div", { className: Styles.floating_placeholder, children: props.widgets.map(([widget, placement], index) => (_jsx("div", { className: Styles.frame, children: _jsx(Common.ErrorBoundary, { children: _jsx(Widget, { id: widget.id, type: Common.WidgetSize.Frame, placementManager: props.placementManager }) }) }, index))) }));
}
